import { api, telecontrol } from "@service";
import { type PostoInfo } from "@pages/Posts/Interfaces";

const tokenV1 = import.meta.env.VITE_API_TOKEN_V1;

export const getPosts = async (code: string) => {
  const response = await api.get(
    `https://britania-api.bcrcx.com/zendesk/telecontrol/posvenda/postos/cnpj/${code}`,
    {
      headers: {
        "client-code": 3,
        "client-secret-key": tokenV1,
        version: "2012-12-12",
        environment: "production",
        "response-format": "json",
        "ip-address": "192.168.0.199",
        "Api-Version": 1,
      },
    }
  );

  return response;
};

export const getAllPosts = async (): Promise<PostoInfo[]> => {
  const response = await api.get<PostoInfo[]>(`/posvenda-core/posto`, {
    headers: {
      "Access-Application-Key": telecontrol,
      "Access-Env": "PRODUCTION",
    },
  });

  return response.data;
};

export const getLineByPost = async (cnpj: string): Promise<{ tabela: string; linha: string }[]> => {
  const response = await api.get<{
    status: string;
    status_code: number;
    status_message: string;
    results: { tabela: string; linha: string }[];
  }>(`https://britania-api.bcrcx.com/zendesk/telecontrol/posvenda/posto_linha/cnpj/${cnpj}`, {
    headers: {
      "client-code": 3,
      "client-secret-key": tokenV1,
      version: "2012-12-12",
      environment: "production",
      "response-format": "json",
      "ip-address": "192.168.0.199",
      "Api-Version": 1,
    },
  });

  return response.data.results;
};

export const getPostByCep = async (cep: string, line?: string) => {
  const endpoint = line ? `linha/${line}` : "";

  const response = await api.get(`/institucional/postoMaisProximo/cep/${cep}/${endpoint}`, {
    headers: {
      "Access-Application-Key": telecontrol,
      "Access-Env": "PRODUCTION",
    },
  });
  return response;
};

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

export const getAddressByCep = async (cep: string): Promise<ViaCepResponse> => {
  const cleanedCep = cep.replace(/\D/g, "");
  const response = await api.get<ViaCepResponse>(`https://viacep.com.br/ws/${cleanedCep}/json/`);
  return response.data;
};
